<!-- =========================================================================================
    File Name: RgSearchJiraTicket.vue
    Description: custom component for jira ticket search
========================================================================================== -->
<template>
   <div>
      <label class="bold">{{ label }}</label>
      <v-select v-bind="$attrs" :value="value" :name="value" @input="$emit('input', $event)" :filterable="false" :options="options"
         @search="onSearch" class="vs-custom w-full">
         <template slot="no-options">
            Ingresa el id del ticket para realizar la búsqueda.
         </template>
         <template slot="option" slot-scope="option">
            <div class="flex justify-start flex-wrap items-center">
               <vs-avatar size="30px" :src="option.img" />
               <div>
                  <span>
                     {{ "(" + option.key + ") " }}
                     {{ truncate(option.summary_text, 50) + "..." }}
                  </span><br>
                  <small>Asignado: {{ option.display_name }} </small>
               </div>
            </div>
         </template>
         <template slot="selected-option" slot-scope="option">
            <div class="flex justify-start flex-wrap items-center">
               <vs-avatar size="30px" :src="option.img" />
               <div>
                  <span>
                     {{ "(" + option.key + ") " }}
                     {{ truncate(option.summary_text, 50) + "..." }}
                  </span>
               </div>
            </div>
         </template>
      </v-select>
   </div>
</template>

<script>
export default {
   name: 'rg-search-jira-ticket',
   inheritAttrs: false,
   props: {
      value: null,
      label: { type: String, default: "Jira ticket" }
   },
   data() {
      return {
         options: []
      }
   },
   methods: {
      truncate(text, length) {
         return text.length > length
            ? text.slice(0, length) + '...'
            : text
      },
      onSearch: _.debounce(async function (search, loading) {
         if (!search) return
         loading(true)
         await this.getJiraTickets(loading, search);
         loading(false)
      }, 400),
      async getJiraTickets(loading, search) {
         await axios.get('/api/cobranza/search-jira-tickets/' + search).then(response => {
            this.options = response.data.map(option => ({
               label: option.key,
               img: option.iconUrl,
               key: option.key,
               summary_text: option.summary,
               display_name: option.displayName,
            }));
            loading(false);
         }).catch(
            loading(false)
         );
      },
   }
};
</script>
